import { memo } from "react";
import { NotificationBadge } from "@/shared/components/NotificationBadge";
import { useAdminNotificationsContext } from "@/shared/contexts/AdminNotificationsProvider";

export const BeneficiaryValidationCounter = memo(() => {
  const { counts } = useAdminNotificationsContext();
  return <NotificationBadge count={counts.beneficiaries_pending_validation} />;
});

BeneficiaryValidationCounter.displayName = "BeneficiaryValidationCounter";
